import { type Maybe } from '@gql/schema';

export enum FlightsSelectOption {
  hotelOnly = 'hotelOnly',
  hotelWithFlights = 'hotelWithFlights',
}

export interface IAirportOption {
  code: string;
  title: string;
}

export type INightsOption = Maybe<number>;
